import { colorsPalettes } from "@similarweb/styles";
import { Dropdown, DropdownButton, SimpleDropdownItem } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

interface IColumnSelectProps {
    options: string[];
    selectedIndex: number;
    disabledIndexes?: number[];
    onChange: (newIndex: number) => void;
}

export const ColumnSelect = ({ options, selectedIndex, disabledIndexes, onChange }: IColumnSelectProps) => {
    const handleChange = (e: { value: number }) => {
        onChange(e.value);
    };

    const buttonText = selectedIndex === -1 ? "Not Selected" : options[selectedIndex];

    return (
        <Dropdown
            onClick={handleChange}
            selectedIds={{ [selectedIndex]: true }}
        >
            {[
                <DropdownButton
                    key="button"
                    width="100%"
                >
                    {selectedIndex === -1 ? (
                        <Text
                            fontVariant="input2"
                            color={colorsPalettes.carbon[200]}
                        >
                            {buttonText}
                        </Text>
                    ) : (
                        buttonText
                    )}
                </DropdownButton>,
                <SimpleDropdownItem
                    // @ts-expect-error if anyone will be able to write proper Dropdown then this will be fixed
                    value={-1}
                    key="not-selected"
                >
                    <Text fontVariant="input2">Not Selected</Text>
                </SimpleDropdownItem>,
                ...options.map((option, index) => (
                    <SimpleDropdownItem
                        // @ts-expect-error if anyone will be able to write proper Dropdown then this will be fixed
                        value={index}
                        disabled={disabledIndexes?.includes(index)}
                        key={index}
                    >
                        {option}
                    </SimpleDropdownItem>
                )),
            ]}
        </Dropdown>
    );
};
